var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLuggageStorePin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 39,
  height: 38,
  fill: "none",
  viewBox: "0 0 39 38"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 32.018,
  height: 32,
  x: 3,
  y: 2,
  fill: "#fff",
  rx: 16,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#454CED",
  fillRule: "evenodd",
  d: "M17.008 15.133v-3.466a1 1 0 0 1 1-1h2.002a1 1 0 0 1 1 1v3.466h1.334q.55 0 .943.392.391.392.392.941V23.8q0 .55-.392.941a1.29 1.29 0 0 1-.943.392.65.65 0 0 1-.191.475.65.65 0 0 1-.476.192.65.65 0 0 1-.475-.192.65.65 0 0 1-.192-.475h-4.002a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192.65.65 0 0 1-.475-.192.65.65 0 0 1-.192-.475q-.55 0-.942-.392a1.28 1.28 0 0 1-.392-.941v-7.334q0-.55.392-.941.391-.392.942-.392zm1.334 0V12h1.334v3.133z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 38.018,
  height: 38,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_16417_22751"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_16417_22751",
  result: "effect2_dropShadow_16417_22751"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_16417_22751",
  result: "shape"
})))));
export default SvgLuggageStorePin;